import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	SelectPicker,
	Notification,
	CheckPicker,
	Checkbox,
	useToaster,
	Carousel,
	IconButton,
	ButtonGroup,
	Button,
} from "rsuite";
import "./categoryPerformance.scss";
import { FILTERDATA, numberFormatter } from "../../utils";
import { appInsights } from "../router";
import NetCostReductionChart from "./netCostReductionChart";
import MarginImprovement from "./marginImprovement";
import PricingExecution from "./pricingExecution";
import SalesGrowth from "./salesGrowth";
import moment from "moment";
import { drillDownType, projectType } from "../constants";
import PerformanceScatter from "./performanceScatter";
import {
	getCategorySummaryData,
	getDashboardFilters,
	getCategoryPerformanceGraphData,
	getAllFiltersPerformance,
	getNIAPerformanceGraphData,
} from "../../queries/apiQueries";
import AngleLeftIcon from "@rsuite/icons/legacy/AngleLeft";
import AngleRightIcon from "@rsuite/icons/legacy/AngleRight";
import { COMMODITY } from "../../config/constants";
import MainContent from "../../components/Layouts/MainContent";
import MainHeader from "../../components/Layouts/MainHeader";
import { Loader } from "../../components/common/Loader";
import { Segmented } from "antd";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { CSVLink } from "react-csv";

const CategoryPerformance = (props: any) => {
	const dispatch = useDispatch<any>();
	const toaster = useToaster();
	var isCleared = false;
	const footerStyles = {
		padding: "10px 2px",
		borderTop: "1px solid #e5e5e5",
	};

	const [filtersLoading, setFiltersLoading] = useState(true);
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const currentView = useSelector(
		(state: any) => state.CommonReducer.currentView
	);

	const [graphData, setGraphData] = useState<any>({});
	const [performanceGraphData, setPerformanceGraphData] = useState<any>({});
	const [performanceFlag, setPerformanceFlag] = useState<any>(false);
	const [selectedScatter, setSelectedScatter] = useState<any>(null);

	const [scatterData, setScatterData] = useState<any>(null);
	const [summaryData, setSummaryData] = useState<any>(null);
	const [summaryDataRes, setSummaryDataRes] = useState<any>(null);
	const [viewBy, setViewBy] = useState(
		allFilters?.type
			? allFilters?.type === "category"
				? "L3"
				: allFilters?.type === "supplier"
				? "Supplier"
				: "District"
			: "L1"
	);
	const [detailView, setDetailView] = useState(false);
	const [selectedViewBy, setSelectedViewBy] = useState<any>(null);
	const [benchmarkingDataFlag, setBenchmarkingDataFlag] = useState<any>(true);
	const [performanceFilterData, setPerformanceFilterData] = useState<any>({});
	const [highlight, setHighlight] = useState<any>(
		currentView?.selectedHighlight
	);
	const [currentViewState, setCurrentViewState] = useState<{
		isSummaryView: boolean;
		viewBy: string;
		selectedHighlight: null | string;
		filters: {
			district: Array<any>;
			l1: Array<any>;
			l2: Array<any>;
			l3: Array<any>;
			supplier: Array<any>;
		};
	}>(currentView);

	console.log(allFilters, "allFilters");

	const [page, setPage] = useState("summary");
	const [selectedProjectType, setSelectedProjectType] = useState<any>(
		allFilters?.projectType?.length !== 0 && allFilters?.projectType !== ""
			? allFilters?.projectType
			: []
	);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isGraphLoading, setIsGraphLoading] = useState(true);
	const [isFilterUpdating, setIsFilterUpdating] = useState(false);
	const [isSummaryGraphLoading, setIsSummaryGraphLoading] = useState(true);
	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		district: new Array<{ district: string }>(),
		supplier: new Array<{ vendor: string }>(),
		supplierB: new Array<{ vendor: string }>(),
		l1B: new Array<{ l1: string }>(),
	});
	const [selectedFilters, setSelectedFilters] = useState<any>(allFilters);
	const [aboveAvgGMCount, setAboveAvgGMCount] = useState<any>(null);
	const [belowAvgGMCount, setBelowAvgGMCount] = useState<any>(null);
	const [aboveCategoryAvgGMCount, setCategoryAboveAvgGMCount] =
		useState<any>(null);
	const [belowCategoryAvgGMCount, setCategoryBelowAvgGMCount] =
		useState<any>(null);
	const [legendColors, setLegendColors] = useState<any>({});
  	const [exportDataDetails, setExportDataDetails] = useState([]);

	const [exportData, setExportData] = useState([]);
	const exportFullRef = useRef<any>(null);
	const didClear: any = useRef(false);
	const filtersMount: any = useRef(false);
	const [commoditySupplier, setCommoditySupplier] = useState(false);
	const [isVisible, setIsVisible] = useState(false);
	const [activeTab, setActiveTab] = useState("category");
	const viewByOptions = [
		{ label: "Category", value: "category" },
		{ label: "Supplier", value: "supplier" },
		{ label: "District", value: "district" },
	];

	const csvHeaders = [
		{ label: "L1", key: "L1" },
		{ label: "L2", key: "L2" },
		{ label: "L3", key: "L3" },
		{ label: "District", key: "District" },
		{ label: "Supplier", key: "Supplier" },
		{ label: "Project/Non Project", key: "ProjectType" },
		{ label: "Month", key: "month" },
		{ label: "Year", key: "year" },
		{ label: "Gross Margin %", key: "gm" },
		{ label: "Sales $", key: "sales" },
		{ label: "Sell Price (For Existing Customers & Products)", key: "sellPrice" },
		{ label: "Cost (For Existing Products)", key: "cost" },
	]


	const slides = [
		<div className="flex w-full gap-x-[2vh] bg-[#fff] ">
			<div className="w-[50%] border-[1px] border-solid border-[#bebebe]">
				<MarginImprovement
					isVisible={isVisible}
					chartData={graphData}
					heading={"Gross Margin"}
					page={page}
				/>
			</div>
			<div className="w-[50%] border-[1px] border-solid border-[#bebebe]">
				<SalesGrowth
					isVisible={isVisible}
					chartData={graphData}
					heading={"Sales ($)"}
					page={page}
				/>
			</div>
		</div>,
		<div className="flex w-full gap-x-[2vh] bg-[#fff]">
			<div className="w-[50%] border-[1px] border-solid border-[#bebebe]">
				<PricingExecution
					isVisible={isVisible}
					chartData={graphData}
					heading={"Sell Price Index ($/Unit)"}
				/>
			</div>
			<div className="w-[50%] border-[1px] border-solid border-[#bebebe]">
				<NetCostReductionChart
					isVisible={isVisible}
					chartData={graphData}
					heading={"Net Cost ($)"}
					page={page}
				/>
			</div>
		</div>,
	];

	const getExportData = () => {
		if (props.exportDataDetails?.length !== 0) {
		exportFullRef?.current?.link.click();
		}
	};

	const [index, setIndex] = useState<any>(0);
	const handleSelect = (nextIndex: number) => {
		setIndex(nextIndex);
	};
	const goPrev = () =>
		setIndex((prev: any) => (prev === 0 ? slides.length - 1 : prev - 1));
	const goNext = () =>
		setIndex((prev: any) => (prev === slides.length - 1 ? 0 : prev + 1));

	const token = useSelector((state: any) => state.CommonReducer.token);

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to Value Tracking by ${localStorage.getItem(
				"user_name"
			)}, ${localStorage.getItem("user_email")}`,
		});

		if (activeTab == "supplier") {
			// setViewBy("Supplier");
			getSummaryData(null, viewBy);
			getPerformanceGraphData();
			getFilters();
		} else if (activeTab == "district") {
			// setViewBy("District");
			getSummaryData(null, viewBy);
			getPerformanceGraphData();
			getFilters();
		} else {
			getSummaryData();
			getPerformanceGraphData();
			getFilters();
		}
	}, [selectedProjectType]);

	useEffect(() => {
		if (!performanceFlag) {
			getFilters();
		}
	}, [performanceFlag]);

	const isMounted1 = useRef(false);
	useEffect(() => {
		setHighlight(null);
		// setSelectedFilters({...selectedFilters,type:null});
	}, [activeTab]);

	useEffect(() => {
		if (token) {
			if (summaryDataRes) {
				if (viewBy == "Supplier") {
					let finalData = [];
					if (summaryDataRes?.master_vendor_name?.scatterData) {
						finalData =
							summaryDataRes?.master_vendor_name?.scatterData.map(
								(data: any) => {
									return {
										grossMargin:
											data.scatterData.grossMargin * 100,
										cagr: data.scatterData.cagr * 100,
										cost: data.cost,
										revenue: data.revenue,
										category: data.category,
										type: data.type,
										color: "white",
									};
								}
							);
					}
					setScatterData(finalData);
					if (summaryDataRes?.master_vendor_name) {
						setSummaryData(summaryDataRes?.master_vendor_name);
					}
				} else {
					let finalData = [];
					if (summaryDataRes[viewBy]) {
						finalData = summaryDataRes[viewBy]?.scatterData.map(
							(data: any) => {
								return {
									grossMargin:
										data.scatterData.grossMargin * 100,
									cagr: data.scatterData.cagr * 100,
									cost: data.cost,
									revenue: data.revenue,
									category: data.category,
									type: data.type,
									color:
										viewBy !== "District"
											? data.color
											: "white",
								};
							}
						);
					}
					setScatterData(finalData);
					if (summaryDataRes[viewBy]) {
						setSummaryData(summaryDataRes[viewBy]);
					}
				}
			}
		}
	}, [viewBy]);

	const isMounted = useRef(false);
	useEffect(() => {
		if (isMounted?.current) {
			console.log(
				!performanceFlag,
				!isFilterUpdating,
				"performance filter"
			);
			if (!performanceFlag && !isFilterUpdating) {
				getPerformanceGraphData();
			}
		} else {
			isMounted.current = true;
		}
		props.onFilterChange({ ...selectedFilters, type: null });
	}, [selectedFilters]);

	useEffect(() => {
		if (allFilters?.type) {
			console.log("ran");
			const newViewBy =
				allFilters?.type === "category"
					? "L3"
					: allFilters?.type === "supplier"
					? "Supplier"
					: "District";
			const filter =
				allFilters?.type === "category"
					? allFilters?.l3[0]
					: allFilters?.type === "supplier"
					? allFilters?.supplier[0]
					: allFilters?.district[0];
			// Update state first
			setActiveTab(allFilters?.type);
			setViewBy(newViewBy);
			console.log(filter, allFilters, "scatterfilter");
			setSelectedScatter(filter);
		}
	}, [allFilters]);

	useEffect(() => {
		if (summaryDataRes) {
			let aboveAvgCount = 0;
			let belowAvgCount = 0;
			summaryDataRes?.District?.scatterData?.map((item: any) => {
				if (
					item?.type == "growCategory" ||
					item?.type == "growthPotential"
				) {
					aboveAvgCount = aboveAvgCount + 1;
				} else {
					belowAvgCount = belowAvgCount + 1;
				}
			});
			setAboveAvgGMCount(aboveAvgCount);
			setBelowAvgGMCount(belowAvgCount);

			let aboveCatAvgCount = 0;
			let belowCatAvgCount = 0;
			summaryDataRes?.L3?.scatterData?.map((item: any) => {
				if (
					item?.type == "growCategory" ||
					item?.type == "growthPotential"
				) {
					aboveCatAvgCount = aboveCatAvgCount + 1;
				} else {
					belowCatAvgCount = belowCatAvgCount + 1;
				}
			});
			setCategoryAboveAvgGMCount(aboveCatAvgCount);
			setCategoryBelowAvgGMCount(belowCatAvgCount);
		}
	}, [summaryDataRes]);

	const getPerformanceGraphData = async (
		selectedTab: any = null,
		selectedL1: any = null,
		selectedL2: any = null,
		selectedL3: any = null,
		selectedSupplier: any = null,
		selectedDistrict: any = null
	) => {
		setIsGraphLoading(true);
		let payload: any = {
			district: selectedFilters.district,
			master_vendor_name: selectedFilters.supplier,
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			type: activeTab,
		};
		if (selectedL1) {
			payload.l1 = selectedL1;
		}
		if (selectedL2) {
			payload.l2 = selectedL2;
		}
		if (selectedL3) {
			payload.l3 = selectedL3;
		}
		if (selectedSupplier) {
			payload.master_vendor_name = selectedSupplier;
		}
		if (selectedDistrict) {
			payload.district = selectedDistrict;
		}
		// Add a null check for selectedProjectType
		payload.projectType =
			!selectedProjectType || selectedProjectType.length === 0
				? []
				: [selectedProjectType];
		if (selectedTab) {
			payload.type = selectedTab;
		}
		if (selectedFilters?.type) {
			payload.type = selectedFilters?.type;
		}
		let res = await dispatch(getCategoryPerformanceGraphData(payload));
		setGraphData(res.data);
		if(res.data){
      
			let finalData: any = [];
			const getFilterValue = (filter:any)=>{
				let value = '';
				payload[filter].map((item:any, index:any)=>{
				if(index>0){
					value = value + ', '
				}
				value = value + item;
				})
				return(value);
			}
			let l1 = payload?.l1?.length>0? getFilterValue('l1') :'All';
			let l2 = payload?.l2?.length>0? getFilterValue('l2') :'All';
			let l3 = payload?.l3?.length>0? getFilterValue('l3') :'All';
			let supplier = payload?.master_vendor_name?.length>0? payload?.master_vendor_name[0] : 'All';
			let district = payload?.district?.length>0? payload?.district[0] : 'All';
			let projectType = payload.projectType.length == 0 ? 'All' : selectedProjectType;
			res?.data?.finalData.map((item:any)=>{
				let a ={
					L1: l1,
					L2: l2,
					L3: l3,
					Supplier: supplier,
					District: district,
					ProjectType: projectType,
					month: moment.utc(item?.month).format("MMM"),
					year: moment.utc().subtract(1, 'years').year(),
					gm: `${(item?.margin_Prev * 100).toFixed(2)}%`,
					sales: `$${item?.sales_Prev.toFixed(2)}`,
					sellPrice: `$${item?.sellPrice_Prev.toFixed(2)}`,
					cost: `$${item?.netCost_Prev.toFixed(2)}`,
				}
				let b ={
					L1: l1,
					L2: l2,
					L3: l3,
					Supplier: supplier,
					District: district,
					ProjectType: projectType,
					month: moment.utc(item?.month).format("MMM"),
					year: moment.utc().format('YYYY'),
					gm: `${(item?.margin_Curr *100).toFixed(2)}%`,
					sales: `$${item?.sales_Curr.toFixed(2)}`,
					sellPrice: `$${item?.sellPrice_Curr.toFixed(2)}`,
					cost: `$${item?.netCost_Curr.toFixed(2)}`,
				}
				finalData.push(a);
				finalData.push(b);
			})
			setExportDataDetails(finalData);
    	}
		setIsGraphLoading(false);
	};

	const getNIAPerformanceGraphDetails = async (value: any = null) => {
		setIsSummaryGraphLoading(true);
		let payloadObject = {
			vendor_name: selectedFilters?.supplier,
			approach: "approach1",
			l1: selectedFilters?.l1B,
		};
		if (value) {
			payloadObject.l1 = [value];
		}
		let res = await dispatch(getNIAPerformanceGraphData(payloadObject));
		res?.data?.peer?.map((item: any) => {
			item.rebate_base_lastyear = item.rebate_base_lastyear * 100;
			item.gm = item.gm * 100;
			item.cagr = item.cagr * 100;
		});

		setSelectedFilters({
			...selectedFilters,
			l1B: value ? [value] : [],
			supplierB: res?.data?.selectedPeer,
		});

		setPerformanceGraphData(res.data);
		setIsSummaryGraphLoading(false);
	};

	const getSummaryData = async (
		payload: any = null,
		drillDownType: any = null,
		selectedL3: any = null,
		selectedSupplier: any = null,
		selectedDistrict: any = null,
		selectedL1: any = null,
		selectedL2: any = null
	) => {
		setIsSummaryGraphLoading(true);
		payload = { ...selectedFilters, ...payload };
		if (!payload) {
			payload = {
				vendor_name: [],
				l1: [],
				l2: [],
				l3: [],
				district: [],
				timeline: "LastYear",
				topData: null,
			};
		} else {
			payload.vendor_name = payload.supplier;
			payload.timeline = "LastYear";
			payload.topData = null;

			// delete payload.supplier;
		}
		// payload.projectType = selectedProjectType;
		if (selectedL1) {
			payload.l1 = selectedL1;
		}
		if (selectedL2) {
			payload.l2 = selectedL2;
		}
		if (selectedL3) {
			payload.l3 = selectedL3;
		}
		if (selectedSupplier) {
			payload.supplier = selectedSupplier;
			payload.vendor_name = selectedSupplier;
		}
		if (selectedDistrict) {
			payload.district = selectedDistrict;
		}
		payload.nofInd = 1;
		let res = await dispatch(getCategorySummaryData(payload));
		setSummaryDataRes(res);
		let legendcolor: any = {};
		res?.L1?.scatterData?.map((item: any) => {
			if (item.category == "ELECTRICAL") {
				legendcolor.electrical = item.color;
			} else if (item.category == "DATA COMMUNICATION") {
				legendcolor.dataCommunication = item.color;
			} else if (item.category == "LIGHTING") {
				legendcolor.lighting = item.color;
			} else if (item.category == "MRO") {
				legendcolor.mro = item.color;
			}
		});
		setLegendColors(legendcolor);
		if (!drillDownType) {
			if (viewBy == "Supplier") {
				let finalData = [];
				if (res?.master_vendor_name?.scatterData) {
					finalData = res?.master_vendor_name?.scatterData.map(
						(data: any) => {
							return {
								grossMargin: data.scatterData.grossMargin * 100,
								cagr: data.scatterData.cagr * 100,
								cost: data.cost,
								revenue: data.revenue,
								category: data.category,
								type: data.type,
								color: "white",
							};
						}
					);
				}
				setScatterData(finalData);
				if (res?.master_vendor_name) {
					setSummaryData(res?.master_vendor_name);
				}
			} else {
				let finalData = [];
				if (res[viewBy]) {
					finalData = res[viewBy]?.scatterData.map((data: any) => {
						return {
							grossMargin: data.scatterData.grossMargin * 100,
							cagr: data.scatterData.cagr * 100,
							cost: data.cost,
							revenue: data.revenue,
							category: data.category,
							type: data.type,
							color: viewBy !== "District" ? data.color : "white",
						};
					});
				}
				setScatterData(finalData);
				if (res[viewBy]) {
					setSummaryData(res[viewBy]);
				}
			}
		} else {
			if (drillDownType == "Supplier") {
				let finalData = [];
				if (res?.master_vendor_name?.scatterData) {
					finalData = res?.master_vendor_name?.scatterData.map(
						(data: any) => {
							return {
								grossMargin: data.scatterData.grossMargin * 100,
								cagr: data.scatterData.cagr * 100,
								cost: data.cost,
								revenue: data.revenue,
								category: data.category,
								type: data.type,
								color: "white",
							};
						}
					);
				}
				setScatterData(finalData);
				if (res?.master_vendor_name) {
					setSummaryData(res?.master_vendor_name);
				}
			} else {
				let finalData = [];
				if (res[drillDownType]) {
					finalData = res[drillDownType]?.scatterData.map(
						(data: any) => {
							return {
								grossMargin: data.scatterData.grossMargin * 100,
								cagr: data.scatterData.cagr * 100,
								cost: data.cost,
								revenue: data.revenue,
								category: data.category,
								type: data.type,
								color:
									viewBy !== "District"
										? data.color
										: "white",
							};
						}
					);
				}
				setScatterData(finalData);
				if (res[drillDownType]) {
					setSummaryData(res[drillDownType]);
				}
			}
		}
		setIsSummaryGraphLoading(false);
	};

	const supplierBenchmarkingFilters = (supplierValue: any = null) => {
		if (supplierValue) {
			getSupplierBenchmarkingFilters({ supplier: supplierValue });
		} else {
			getSupplierBenchmarkingFilters({
				supplier: selectedFilters.supplier,
			});
		}
	};

	const handleClicks = (value: any, isFilter: boolean = false) => {
		setSelectedViewBy(viewBy);
		setSelectedScatter(value);

		console.log(viewBy, value, "handle");

		if (activeTab == "category") {
			setHighlight(value);
			setCurrentViewState({
				...currentViewState,
				selectedHighlight: value,
			});
			if (viewBy == "L1") {
				if (selectedFilters.l1.length > 0) {
					//second time clicking on the bubble
					setSelectedFilters({
						...selectedFilters,
						l1: [],
						l2: [],
						l3: [],
						supplier: [],
						district: [],
					});
					getFilters(
						{
							...selectedFilters,
							l1: [],
							l2: [],
							l3: [],
							supplier: [],
						},
						"l1"
					);
					getSummaryData(null, "L1", null, null, null, []);
					setHighlight(null);
				} else {
					setSelectedFilters({
						...selectedFilters,
						l1: value ? [value] : [],
						l2: [],
						l3: [],
						supplier: [],
						district: [],
					});
					getFilters(
						{
							...selectedFilters,
							l1: value ? [value] : [],
							l2: [],
							l3: [],
							supplier: [],
						},
						"l1"
					);
					getSummaryData(
						null,
						"L1",
						null,
						null,
						null,
						value ? [value] : []
					);
				}
			} else if (viewBy == "L2") {
				if (selectedFilters.l2.length > 0) {
					//second time clicking on the bubble
					setSelectedFilters({
						...selectedFilters,
						l2: [],
						l3: [],
						supplier: [],
						district: [],
					});
					getFilters(
						{ ...selectedFilters, l2: [], l3: [], supplier: [] },
						"l2"
					);
					getSummaryData(null, "L2", null, null, null, null, []);
					setHighlight(null);
				} else {
					setSelectedFilters({
						...selectedFilters,
						l2: value ? [value] : [],
						l3: [],
						supplier: [],
						district: [],
					});
					getFilters(
						{
							...selectedFilters,
							l2: value ? [value] : [],
							l3: [],
							supplier: [],
						},
						"l2"
					);
					getSummaryData(
						null,
						"L2",
						null,
						null,
						null,
						null,
						value ? [value] : []
					);
				}
			} else if (viewBy == "L3") {
				if (selectedFilters.l3.length > 0) {
					//second time clicking on the bubble
					setSelectedFilters({
						...selectedFilters,
						l3: [],
						supplier: [],
						district: [],
					});
					getFilters(
						{ ...selectedFilters, l3: [], supplier: [] },
						"l3"
					);
					getSummaryData(null, "L3", []);
					setHighlight(null);
				} else {
					setSelectedFilters({
						...selectedFilters,
						l3: value ? [value] : [],
						supplier: [],
						district: [],
					});
					getFilters(
						{
							...selectedFilters,
							l3: value ? [value] : [],
							supplier: [],
						},
						"l3"
					);
					getSummaryData(null, "L3", value ? [value] : []);
				}
			} else if (viewBy == "Supplier") {
				if (highlight == value) {
					setHighlight(null);
					setSelectedFilters({
						...selectedFilters,
						supplier: [],
						district: [],
					});
				} else {
					setSelectedFilters({
						...selectedFilters,
						supplier: value ? [value] : [],
						district: [],
					});
				}
			} else if (viewBy == "District") {
				if (highlight == value) {
					setHighlight(null);
					setSelectedFilters({
						...selectedFilters,
						supplier: [],
						district: [],
					});
				} else {
					setSelectedFilters({
						...selectedFilters,
						supplier: [],
						district: value ? [value] : [],
					});
				}
			}
		} else if (activeTab == "supplier") {
			setHighlight(value);

			if (viewBy == "District") {
				setSelectedFilters({
					...selectedFilters,
					district: value ? [value] : [],
				});
				getFilters(
					{ ...selectedFilters, district: value ? [value] : [] },
					"supplier"
				);
			} else if (viewBy == "L3") {
				setSelectedFilters({
					...selectedFilters,
					l3: value ? [value] : [],
					district: [],
				});
				getFilters(
					{ ...selectedFilters, l3: value ? [value] : [] },
					"supplier"
				);
			} else {
				if (highlight == value) {
					setHighlight(null);
					setSelectedFilters({
						...selectedFilters,
						supplier: [],
						district: [],
					});
					getFilters(
						{ ...selectedFilters, district: [], supplier: [] },
						"supplier"
					);
				} else {
					setSelectedFilters({
						...selectedFilters,
						supplier: value ? [value] : [],
						district: [],
					});
					getFilters(
						{
							...selectedFilters,
							district: [],
							supplier: value ? [value] : [],
						},
						"supplier"
					);
				}
			}

			//  if (!performanceFlag) {
			//   setViewBy("District");
			// }
		} else if (activeTab == "district") {
			setHighlight(value);
			if (viewBy == "Supplier" && !isFilter) {
				console.log(1);
				setSelectedFilters({
					...selectedFilters,
					supplier: value ? [value] : [],
				});
				getFilters(
					{ ...selectedFilters, supplier: value ? [value] : [] },
					"district"
				);
			} else if (viewBy == "L3" && !isFilter) {
				console.log(2);
				setSelectedFilters({
					...selectedFilters,
					l3: value ? [value] : [],
				});
				getFilters(
					{ ...selectedFilters, l3: value ? [value] : [] },
					"district"
				);
			} else {
				if (highlight == value) {
					console.log(3);
					setHighlight(null);
					setSelectedFilters({
						...selectedFilters,
						supplier: [],
						district: [],
					});
					getFilters(
						{ ...selectedFilters, supplier: [], district: [] },
						"district"
					);
				} else {
					console.log(4);
					setSelectedFilters({
						...selectedFilters,
						district: value ? [value] : [],
						supplier: [],
					});
					getFilters(
						{
							...selectedFilters,
							district: value ? [value] : [],
							supplier: [],
						},
						"district"
					);
				}
				// setViewBy("Supplier");
			}
		}
	};

	const handleDrillDownSelection = (
		selectedDrillDownType: any,
		selectedData: any
	) => {
		if (activeTab == "category") {
			setSelectedFilters({
				...selectedFilters,
				l3: [selectedData?.category],
			});
			if (selectedDrillDownType == "supplier") {
				setViewBy("Supplier");
				getSummaryData(null, "Supplier", [selectedData?.category]);
			} else if (selectedDrillDownType == "district") {
				setViewBy("District");
				getSummaryData(null, "District", [selectedData?.category]);
			}
		} else if (activeTab == "supplier") {
			setSelectedFilters({
				...selectedFilters,
				supplier: [selectedData?.category],
			});
			if (selectedDrillDownType == "l3") {
				setViewBy("L3");
				getSummaryData(null, "L3", null, [selectedData?.category]);
			} else if (selectedDrillDownType == "district") {
				setViewBy("District");
				getSummaryData(null, "District", null, [
					selectedData?.category,
				]);
			} else if (selectedDrillDownType == "supplierBenchmarking") {
				setViewBy("Supplier Benchmarking");
				supplierBenchmarkingFilters([selectedData?.category]);
				setPerformanceFlag(true);
				getSummaryData(null, null, null, [selectedData?.category]);
			}
		} else if (activeTab == "district") {
			setSelectedFilters({
				...selectedFilters,
				district: [selectedData?.category],
			});
			if (selectedDrillDownType == "l3") {
				setViewBy("L3");
				getSummaryData(null, "L3", null, null, [
					selectedData?.category,
				]);
			} else if (selectedDrillDownType == "supplier") {
				setViewBy("Supplier");
				getSummaryData(null, "Supplier", null, null, [
					selectedData?.category,
				]);
			}
		}
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null,
		clearFlag: any = null
	) => {
		console.log(payload, currentFilter, fo, clearFlag, "filtersetting");
		setFiltersLoading(true);
		if (payload.supplier) {
			payload.master_vendor_name = payload.supplier;
			// delete payload.supplier;
		}
		payload.nofInd = 1;
		// Add a null check for selectedProjectType
		payload.projectType =
			!selectedProjectType || selectedProjectType.length === 0
				? []
				: [selectedProjectType];
		let res = await dispatch(getDashboardFilters(payload));
		setTimeout(() => {
			setFiltersLoading(false);
		}, 100);
		if (fo) {
			fo.supplier = fo.suppliers;
			fo.district = fo.districts;
			delete fo.districts;
			delete fo.suppliers;
			if (currentFilter === "district") {
				updateFilterOptions({
					...fo,
					l1: [...res.l1],
					l2: [...res.l2],
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({ ...fo, supplier: [...res.suppliers] });
			} else if (currentFilter === "supplier") {
				updateFilterOptions({
					...fo,
					l1: [...res.l1],
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					district: res.districts,
					supplier: res.suppliers,
				});
			}
		} else {
			if (currentFilter === "district") {
				updateFilterOptions({
					...filterOptions,
					l1: [...res.l1],
					l2: [...res.l2],
					l3: [...res.l3],
					supplier: [...res.suppliers],
				});
			} else if (currentFilter === "l1") {
				// Add a null check for selectedFilters.l1
				if (
					!selectedFilters.l1 ||
					selectedFilters.l1.length === 0 ||
					clearFlag
				) {
					updateFilterOptions({
						...filterOptions,
						l1: [...res.l1],
						l2: [...res.l2],
						l3: [...res.l3],
						supplier: [...res.suppliers],
					});
				} else {
					updateFilterOptions({
						...filterOptions,
						l2: [...res.l2],
						l3: [...res.l3],
						supplier: [...res.suppliers],
					});
				}
			} else if (currentFilter === "l2") {
				// Add a null check for selectedFilters.l2
				if (
					!selectedFilters.l2 ||
					selectedFilters.l2.length === 0 ||
					clearFlag
				) {
					updateFilterOptions({
						...filterOptions,
						l1: [...res.l1],
						l2: [...res.l2],
						l3: [...res.l3],
						supplier: [...res.suppliers],
					});
				} else {
					updateFilterOptions({
						...filterOptions,
						l3: [...res.l3],
						supplier: [...res.suppliers],
					});
				}
			} else if (currentFilter === "l3") {
				// Add a null check for selectedFilters.l3
				if (
					!selectedFilters.l3 ||
					selectedFilters.l3.length === 0 ||
					clearFlag
				) {
					updateFilterOptions({
						...filterOptions,
						l1: [...res.l1],
						l2: [...res.l2],
						l3: [...res.l3],
						supplier: [...res?.suppliers],
					});
				} else {
					updateFilterOptions({
						...filterOptions,
						supplier: [...res?.suppliers],
					});
				}
			} else if (currentFilter === "supplier") {
				if (payload.supplier == 0 || clearFlag) {
					updateFilterOptions({
						...filterOptions,
						l1: [...res.l1],
						l2: [...res.l2],
						l3: [...res.l3],
						supplier: [...res?.suppliers],
					});
				} else {
					updateFilterOptions({
						...filterOptions,
						l1: [...res.l1],
						l2: [...res.l2],
						l3: [...res.l3],
					});
				}
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					district: res.districts,
					supplier: res.suppliers,
				});
			}
		}
		setIsLoading(false);
		filtersMount.current = false;
		// setSelectedRecommendationItem(null);
		return res;
	};

	/* Filters api call */
	const getSupplierBenchmarkingFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		setFiltersLoading(true);
		if (payload.supplier) {
			payload.master_vendor_name = payload.supplier;
			delete payload.supplier;
		} else {
			payload.master_vendor_name = selectedFilters.supplier;
		}
		let res = await dispatch(getAllFiltersPerformance(payload));
		setTimeout(() => {
			setFiltersLoading(false);
		}, 100);
		if (res) {
			let dummy: any = [];
			res?.l1?.map((item: any) => {
				dummy[`${item.L1}`] = [];
				Object.keys(item.Peers).map((p: any) => {
					dummy[`${item.L1}`].push({ vendor: p });
				});
			});
			setPerformanceFilterData(dummy);
			updateFilterOptions({
				l1B: res.l1,
			});
		} else {
			setBenchmarkingDataFlag(false);
			updateFilterOptions({
				l1: [],
				supplier: [],
			});
		}
		setIsLoading(false);
		filtersMount.current = false;
		// setSelectedRecommendationItem(null);
		return res;
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		if (isCleared) {
			isCleared = false;
			return;
		}
		filtersMount.current = true;
		let x: string = filter;
		if (value === "all") {
			if (filterOptions?.[x].length === selectedFilters?.[x].length) {
				setSelectedFilters({ ...selectedFilters, [x]: [] });
			} else {
				if (x == "supplier") {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option.vendor
							),
						],
					});
				} else if (x == "supplierB") {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option.vendor
							),
						],
					});
				} else {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option?.[x]
							),
						],
					});
				}
			}
		} else {
			// setSelectedFilters({})
			if (x == "l1B") {
				setSelectedFilters({ ...selectedFilters, [x]: [value] });
				// selectedFilters[x] = [value];
				updateFilterOptions({
					...filterOptions,
					supplierB: performanceFilterData[value],
				});
				getNIAPerformanceGraphDetails(value);
			} else if (x != "supplierB") {
				setSelectedFilters({
					...selectedFilters,
					[x]: [...value],
					["l1B"]: [],
				});
			}
			if (x == "supplier") {
				getFilters(
					{ ...selectedFilters, supplier: value, district: [] },
					"supplier"
				);
			}
			if (x == "district") {
				getFilters(
					{ ...selectedFilters, district: value, supplier: [] },
					"district"
				);
			}
			if (x == "supplierB") {
				setSelectedFilters({ ...selectedFilters, [x]: [...value] });
			}
		}
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		setIsFilterUpdating(false);
		if (filter === "district") {
			// setSelectedFilters({
			//   ...selectedFilters,
			//   l1: [],
			//   l2: [],
			//   l3: [],
			//   supplier: [],
			// });
			getFilters(
				{ ...selectedFilters, l1: [], l2: [], l3: [], supplier: [] },
				"district"
			);
			getSummaryData({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
		} else if (filter === "l1") {
			setHighlight(null);
			if (performanceFlag) {
				// getNIAPerformanceGraphDetails();
			} else {
				setSelectedFilters({
					...selectedFilters,
					l2: [],
					l3: [],
				});

				if (activeTab == "supplier") {
					// setViewBy("Supplier");
					getSummaryData(
						{ ...selectedFilters, l2: [], l3: [], district: [] },
						viewBy
					);
					getFilters(
						{ ...selectedFilters, l2: [], l3: [], district: [] },
						"l1"
					);
				} else if (activeTab == "district") {
					// setViewBy("District");
					getSummaryData(
						{ ...selectedFilters, l2: [], l3: [], supplier: [] },
						viewBy
					);
					getFilters(
						{ ...selectedFilters, l2: [], l3: [], supplier: [] },
						"l1"
					);
				} else {
					getSummaryData({
						...selectedFilters,
						l2: [],
						l3: [],
						supplier: [],
						district: [],
					});
					getFilters(
						{
							...selectedFilters,
							l2: [],
							l3: [],
							supplier: [],
							district: [],
						},
						"l1"
					);
				}
			}
		} else if (filter === "l2") {
			setSelectedFilters({
				...selectedFilters,
				l3: [],
			});
			setHighlight(null);
			// setSelectedFilters({ ...selectedFilters, l3: [], supplier: [], district:[] });

			if (activeTab == "supplier") {
				// setViewBy("Supplier");
				getSummaryData(
					{ ...selectedFilters, l3: [], district: [] },
					viewBy
				);
				getFilters({ ...selectedFilters, l3: [], district: [] }, "l2");
			} else if (activeTab == "district") {
				// setViewBy("District");
				getSummaryData(
					{ ...selectedFilters, l3: [], supplier: [] },
					viewBy
				);
				getFilters({ ...selectedFilters, l3: [], supplier: [] }, "l2");
			} else {
				getSummaryData({
					...selectedFilters,
					l3: [],
					supplier: [],
					district: [],
				});
				getFilters(
					{ ...selectedFilters, l3: [], supplier: [], district: [] },
					"l2"
				);
			}
		} else if (filter === "l3") {
			setSelectedFilters({
				...selectedFilters,
			});
			setHighlight(null);
			// setSelectedFilters({ ...selectedFilters, supplier: [],  district:[] });

			if (activeTab == "supplier") {
				// setViewBy("Supplier");
				getSummaryData({ ...selectedFilters, district: [] }, viewBy);
				getFilters({ ...selectedFilters, district: [] }, "l3");
			} else if (activeTab == "district") {
				// setViewBy("District");
				getSummaryData({ ...selectedFilters, supplier: [] }, viewBy);
				getFilters({ ...selectedFilters, supplier: [] }, "l3");
			} else {
				getSummaryData({
					...selectedFilters,
					supplier: [],
					district: [],
				});
				getFilters(
					{ ...selectedFilters, supplier: [], district: [] },
					"l3"
				);
			}
		} else if (filter === "supplier") {
			getFilters({ ...selectedFilters }, "supplier");
			getSummaryData({ ...selectedFilters });
		}
	};

	const handleClear = (filter: string) => {
		isCleared = true;
		if (filter === "district") {
			setSelectedFilters({
				// district: [],
				l1: [],
				l2: [],
				l3: [],
				// supplier: [],
			});

			getFilters(
				{ district: [], l1: [], l2: [], l3: [], supplier: [] },
				"district"
			);
			getSummaryData({
				district: [],
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
		} else if (filter === "l1") {
			setHighlight(null);
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				// supplier: [],
				// district:[],
			});
			if (performanceFlag) {
				// getSupplierBenchmarkingFilters({ ...selectedFilters, supplier: [] }, "l1");
			} else {
				getFilters(
					{ ...selectedFilters, l1: [], l2: [], l3: [] },
					"l1",
					null,
					"clear"
				);
				getSummaryData({
					...selectedFilters,
					l1: [],
					l2: [],
					l3: [],
				});
			}
		} else if (filter === "l2") {
			setHighlight(null);
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [] });
			getFilters(
				{ ...selectedFilters, l2: [], l3: [] },
				"l2",
				null,
				"clear"
			);
			getSummaryData({ ...selectedFilters, l2: [], l3: [] });
		} else if (filter === "l3") {
			setHighlight(null);
			// handleClose('l2');
			setSelectedFilters({ ...selectedFilters, l3: [] });
			getFilters({ ...selectedFilters, l3: [] }, "l3", null, "clear");
			getSummaryData({ ...selectedFilters, l3: [] });
		} else if (filter === "supplier") {
			// setSelectedFilters({ ...selectedFilters, supplier: [] });
			getFilters(
				{ ...selectedFilters, supplier: [] },
				"supplier",
				null,
				"clear"
			);
			getSummaryData({ ...selectedFilters, supplier: [] });
		} else if (filter === "supplierB") {
			setSelectedFilters({ ...selectedFilters, supplierB: [] });
		}
	};

	/* on changing project type */
	const projectTypeHandler = (e: any) => {
		setSelectedProjectType(e === null ? "All" : e);
		setHighlight(null);
	};

	useEffect(() => {
		if (exportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [exportData]);

	useEffect(() => {
		console.log(filterOptions, selectedFilters, "comoddity");
		if (activeTab === "supplier" && filterOptions && selectedFilters) {
			// console.log(filterOptions?.l1B?.length===1,filterOptions?.l1B,filterOptions?.l1B[0]?.L1B==='Electrical',COMMODITY?.includes(selectedFilters?.supplier[0]))
			if (
				filterOptions?.l1B?.length === 1 &&
				filterOptions?.l1B[0]?.L1 === "Electrical"
			) {
				if (COMMODITY?.includes(selectedFilters?.supplier[0])) {
					setCommoditySupplier(true);
				}
			} else if (
				selectedFilters?.l1B &&
				selectedFilters?.l1B[0] === "Electrical"
			) {
				setCommoditySupplier(
					COMMODITY?.includes(selectedFilters?.supplier[0])
						? true
						: false
				);
			} else {
				setCommoditySupplier(false);
			}
		}
	}, [selectedFilters?.supplier, selectedFilters?.l1B, filterOptions?.l1B]);

	const handleViewByChange = (value: any) => {
		// Reset filters
		setSelectedFilters({
			...selectedFilters,
			supplier: [],
			district: [],
			type: null,
		});
		getFilters({
			...selectedFilters,
			district: [],
			supplier: [],
		});

		// Update tab and viewBy
		setActiveTab(value);

		if (value === "category") {
			if (performanceFlag) setPerformanceFlag(false);
			setViewBy("L1");
			getSummaryData(null, "L1", null, [], []);
		} else if (value === "supplier") {
			if (performanceFlag) setPerformanceFlag(false);
			setViewBy("Supplier");
			getSummaryData(null, "Supplier", null, [], []);
		} else if (value === "district") {
			if (performanceFlag) setPerformanceFlag(false);
			setViewBy("District");
			getSummaryData(null, "District", null, [], []);
		}
	};

	return isLoading ? (
		<Loader />
	) : (
		<>
			<div className="valueCapture-container w-full">
				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<>
							<div className="flex justify-between items-center w-full">
								<div className="text-left pageline">
									<span className="pagelinestart">
										Baseline and Performance
									</span>{" "}
									<span className="pagelineslash">/</span>{" "}
									<span className="pagelinesub">
										Category Performance
									</span>
								</div>
							</div>
							<div className="execution-level-wrapper">
								<div className="execution-level-title">
									View By
								</div>
								<div className="flex menus">
									<Segmented
										options={viewByOptions}
										value={activeTab}
										onChange={handleViewByChange}
									/>
									<div className="filter-flex border-1 max-w-fit">
										<div className="flex justify-center items-center h-full">
											<Button
												className="bg-transparent hover:bg-transparent"
												onClick={getExportData}
											>
												<FileDownloadIcon
													color="black"
													className="text-fsre16"
												/>
											</Button>
										</div>
										<CSVLink
											ref={exportFullRef}
											data={exportDataDetails}
											headers={csvHeaders}
											filename="graphData.csv"
											className="hidden"
											target="_blank"
											>
											{" "}
										</CSVLink>
									</div>
								</div>
							</div>
						</>
					}
					bottomContent={
						<>
							{performanceFlag && (
								<>
									<div className="sub-heading-text font-bold flex flex-col items-start">
										<span className="filterHead ">L1</span>
										<SelectPicker
											data={
												filterOptions?.l1B?.length
													? filterOptions?.l1B
													: []
											}
											labelKey="L1"
											valueKey="L1"
											value={
												selectedFilters?.l1B
													? selectedFilters?.l1B[0]
													: []
											}
											cleanable={false}
											onChange={(value: any) => {
												handleFilterUpdate(
													value,
													"l1B"
												);
											}}
										/>
									</div>
								</>
							)}
							<>
								{["l1", "l2", "l3"].map(
									(filterEntity: string, index: number) => {
										return filterEntity == "l1" &&
											performanceFlag ? (
											""
										) : (
											<div
												key={filterEntity}
												className="sub-heading-text font-bold flex flex-col items-start"
											>
												<span className="filterHead">
													{filterEntity}
												</span>
												<CheckPicker
													data={
														filterOptions[
															filterEntity
														]?.length
															? filterOptions[
																	filterEntity
															  ]
															: []
													}
													placeholder="All"
													labelKey={
														filterEntity == "l1" &&
														performanceFlag
															? "L1"
															: filterEntity
													}
													valueKey={
														filterEntity == "l1" &&
														performanceFlag
															? "L1"
															: filterEntity
													}
													disabled={
														filterEntity != "l1"
															? performanceFlag
															: false
													}
													value={
														selectedFilters[
															filterEntity
														]
															? selectedFilters[
																	filterEntity
															  ]
															: []
													}
													onClose={() =>
														filtersMount.current
															? handleClose(
																	filterEntity
															  )
															: setIsFilterUpdating(
																	false
															  )
													}
													onOpen={() => {
														setIsFilterUpdating(
															true
														);
													}}
													onClean={() => {
														handleClear(
															filterEntity
														);
														// if(activeTab == 'category'){
														//   setViewBy('L1');
														// }
													}}
													onChange={(value: any) =>
														handleFilterUpdate(
															value,
															filterEntity
														)
													}
													loading={filtersLoading}
													renderExtraFooter={() => (
														<div
															style={footerStyles}
														>
															<Checkbox
																indeterminate={
																	selectedFilters[
																		filterEntity
																	]?.length >
																		0 &&
																	selectedFilters[
																		filterEntity
																	]?.length <
																		filterOptions[
																			filterEntity
																		]
																			?.length
																}
																checked={
																	selectedFilters[
																		filterEntity
																	]
																		?.length ===
																	filterOptions[
																		filterEntity
																	]?.length
																}
																onChange={(
																	value: any
																) =>
																	handleFilterUpdate(
																		"all",
																		filterEntity
																	)
																}
															>
																Check all
															</Checkbox>
														</div>
													)}
												/>
											</div>
										);
									}
								)}
								<div className="sub-heading-text font-bold flex flex-col items-start">
									<span className="filterHead ">
										Project Type
									</span>
									<SelectPicker
										data={
											projectType.length
												? projectType
												: []
										}
										placeholder="All"
										disabled={performanceFlag}
										value={selectedProjectType}
										defaultValue={
											projectType.length
												? projectType[0].value
												: ""
										}
										onChange={projectTypeHandler}
										cleanable={false}
									/>
								</div>
							</>
						</>
					}
				></MainHeader>
				<MainContent isVisible={isVisible} fullHeight={true}>
					<div className="flex flex-col h-[full] overflow-y-hidden">
						<div className={`flex h-full  gap-[1vw]`}>
							<div
								className={`flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start`}
								style={{ borderRadius: ".5vh" }}
							>
								<p
									className={`m-[1vh] text-center font-bold border-b-[1px] border-[#00000036] ${
										activeTab == "supplier" ? "" : ""
									}`}
								>
									SPEND
								</p>
								<div
									className={`flex w-full ${
										activeTab == "supplier"
											? "pl-[1vh]"
											: ""
									} pt-[.5vh]`}
								>
									<div
										className={`w-[50%] flex flex-col justify-center items-center gap-x-[1vh] border-r border-[#00000036]`}
									>
										<span>2025</span>
										<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
											{numberFormatter(
												graphData?.cardData?.spend2024,
												2,
												"$"
											)}
										</div>
									</div>
									<div
										className={`w-[50%] flex flex-col justify-center gap-x-[1vh] items-center`}
									>
										<span
											className={`${
												activeTab == "supplier"
													? ""
													: "pl-[1vh]"
											}`}
										>
											2026F
										</span>
										<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
											{numberFormatter(
												graphData?.cardData?.spend2025,
												2,
												"$"
											)}
										</div>
									</div>
								</div>
								<div className="flex w-full justify-end">
									<span
										className={` font-bold`}
										style={{
											color:
												graphData?.cardData?.spend2025 -
													graphData?.cardData
														?.spend2024 <
												0
													? "#d55454"
													: "#008b00",
										}}
									>
										{graphData?.cardData?.spend2025 -
											graphData?.cardData?.spend2024 <
										0
											? "-"
											: "+"}
										{numberFormatter(
											graphData?.cardData?.spend2025 -
												graphData?.cardData?.spend2024,
											1,
											"",
											true
										)}
										{`(${
											graphData?.cardData?.spend2025 -
												graphData?.cardData?.spend2024 <
											0
												? "-"
												: ""
										}${numberFormatter(
											((graphData?.cardData?.spend2025 -
												graphData?.cardData
													?.spend2024) /
												graphData?.cardData
													?.spend2024) *
												100,
											1,
											"",
											true
										)}%)`}
									</span>
								</div>
							</div>
							<div
								className={`flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start`}
								style={{ borderRadius: ".5vh" }}
							>
								<p
									className={`m-[1vh] text-center font-bold border-b-[1px] border-[#00000036] ${
										activeTab == "supplier" ? "" : ""
									}`}
								>
									SALES
								</p>
								<div className={`flex w-full pt-[.5vh]`}>
									<div
										className={`w-[50%] flex flex-col justify-center items-center gap-x-[1vh] border-r border-[#00000036]`}
									>
										<span>2025</span>
										<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
											{numberFormatter(
												graphData?.cardData?.sales2024,
												2,
												"$"
											)}
										</div>
									</div>
									<div
										className={`w-[50%] flex flex-col justify-center gap-x-[1vh] items-center`}
									>
										<span
											className={`${
												activeTab == "supplier"
													? ""
													: "pl-[1vh]"
											}`}
										>
											2026F
										</span>
										<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
											{numberFormatter(
												graphData?.cardData?.sales2025,
												2,
												"$"
											)}
										</div>
									</div>
								</div>
								<div className="flex w-full justify-end">
									<span
										className={` font-bold`}
										style={{
											color:
												graphData?.cardData?.sales2025 -
													graphData?.cardData
														?.sales2024 <
												0
													? "#d55454"
													: "#008b00",
										}}
									>
										{graphData?.cardData?.sales2025 -
											graphData?.cardData?.sales2024 <
										0
											? "-"
											: "+"}
										{numberFormatter(
											graphData?.yoyDollar,
											1,
											"",
											true
										)}
										{`(${
											graphData?.cardData?.sales2025 -
												graphData?.cardData?.sales2024 <
											0
												? "-"
												: ""
										}${numberFormatter(
											graphData?.yoy * 100,
											1,
											"",
											true
										)}%)`}
									</span>
								</div>
							</div>
							<div
								className={`flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start`}
								style={{ borderRadius: ".5vh" }}
							>
								<p
									className={`m-[1vh] text-center font-bold border-b-[1px] border-[#00000036]`}
								>
									GROSS MARGIN %
								</p>
								<div className={`flex w-full pt-[.5vh]`}>
									<div
										className={`w-[50%] flex flex-col justify-center items-center gap-x-[1vh] border-r border-[#00000036]`}
									>
										<span>2025</span>
										<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
											{numberFormatter(
												graphData?.cardData?.gm2024 *
													100,
												2
											)}
											%
										</div>
									</div>
									<div
										className={`w-[50%] flex flex-col justify-center gap-x-[1vh] items-center`}
									>
										<span
											className={`${
												activeTab == "supplier"
													? ""
													: "pl-[1vh]"
											}`}
										>
											YTD 2026
										</span>
										<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
											{numberFormatter(
												graphData?.cardData?.gm2025 *
													100,
												2
											)}
											%
										</div>
									</div>
								</div>
								<div className="flex w-full justify-end">
									<span
										className={` font-bold`}
										style={{
											color:
												graphData?.cardData?.gm2025 -
													graphData?.cardData
														?.gm2024 <
												0
													? "#d55454"
													: "#008b00",
										}}
									>
										{graphData?.cardData?.gm2025 -
											graphData?.cardData?.gm2024 <
										0
											? "-"
											: "+"}
										{numberFormatter(
											(graphData?.cardData?.gm2025 -
												graphData?.cardData?.gm2024) *
												100,
											1
										)}
										%
									</span>
								</div>
							</div>
							{activeTab == "supplier" && (
								<div
									className={`flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start`}
									style={{ borderRadius: ".5vh" }}
								>
									<div className="flex justify-center items-center m-[1vh] border-b-[1px] border-[#00000036]">
										<p className="text-center font-bold">
											NIA ($)*
										</p>
										<span className=" opacity-[0.8] ml-2">
											At supplier level
										</span>
									</div>
									<div className="flex w-full pt-[.5vh]">
										<div className="w-[50%] flex flex-col pr-[2vh] justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
											<span>2025</span>
											<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
												{graphData?.nia
													? numberFormatter(
															graphData?.nia
																?.lastYearRebate,
															2,
															"$"
													  )
													: "-"}
											</div>
										</div>
										<div className="w-[50%] flex flex-col pr-[2vh] pl-[2vh] justify-center gap-x-[1vh] items-center">
											<span>2026</span>
											<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
												{graphData?.nia
													? numberFormatter(
															graphData?.nia
																?.currenEffectiveRebateDollar,
															2,
															"$"
													  )
													: "-"}
											</div>
										</div>
									</div>
									{selectedFilters?.district?.length > 0 ||
									selectedFilters?.supplier?.length > 0 ? (
										<div className="flex w-full justify-between px-[1vh]">
											<span className="opacity-[.8]"></span>
											<span
												className="mr-[1vh]  font-bold"
												style={{
													color:
														graphData?.nia
															?.currenEffectiveRebateDollar -
															graphData?.nia
																?.lastYearRebate <
														0
															? "#d55454"
															: "#008b00",
												}}
											>
												{graphData?.nia
													?.currenEffectiveRebateDollar -
													graphData?.nia
														?.lastYearRebate <
												0
													? "-"
													: "+"}
												{graphData?.nia
													? `${numberFormatter(
															((graphData?.nia
																?.currenEffectiveRebateDollar -
																graphData?.nia
																	?.lastYearRebate) /
																graphData?.nia
																	?.lastYearRebate) *
																100,
															1
													  )}%`
													: 0}
											</span>
										</div>
									) : null}
								</div>
							)}
							{(activeTab == "supplier" ||
								activeTab == "district") && (
								<div
									className={`flex-1 ${
										selectedFilters?.district?.length > 0 ||
										selectedFilters?.supplier?.length > 0
											? "min-w-[14.3vw]"
											: ""
									} flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start`}
									style={{ borderRadius: ".5vh" }}
								>
									<p
										className={`m-[1vh] text-center font-bold border-b-[1px] border-[#00000036] ${
											activeTab == "supplier" ? "" : ""
										}`}
									>
										CATEGORY PERFORMANCE
									</p>
									{selectedFilters?.district?.length > 0 ||
									selectedFilters?.supplier?.length > 0 ? (
										<div
											className={`flex w-full pl-[.5vh] pt-[.5vh]`}
										>
											<div
												className={`w-[50%] flex flex-col ${
													activeTab == "supplier"
														? "flex-col pr-[1vh]"
														: "pr-[1vh]"
												} justify-center items-center gap-x-[.5vh] border-r border-[#00000036]`}
											>
												<span className="pl-[0]">{`#Cat > avg GM%`}</span>
												<div className="font-bold text-[#008b00] bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
													{aboveCategoryAvgGMCount}
												</div>
											</div>
											<div
												className={`w-[50%] flex flex-col ${
													activeTab == "supplier"
														? "flex-col pr-[.5vh] pl-[1vh]"
														: " pl-[.5vh] pr-[1vh]"
												} justify-center gap-x-[.5vh] items-center`}
											>
												<span
													className={`${
														activeTab == "supplier"
															? ""
															: "pl-[0vh]"
													}`}
												>
													{"#Cat < avg GM%"}
												</span>
												<div className="font-bold text-[#d55454] bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
													{belowCategoryAvgGMCount}
												</div>
											</div>
										</div>
									) : (
										<div className="w-full h-full flex justify-center items-center opacity-[.8] pb-[2vh] px-[1vh]">
											Please select a{" "}
											{activeTab == "supplier"
												? "supplier"
												: "district"}{" "}
											to see the details
										</div>
									)}
								</div>
							)}
							{activeTab == "category" && (
								<div
									className="flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start "
									style={{ borderRadius: ".5vh" }}
								>
									<p className="m-[1vh] text-center font-bold border-b-[1px] border-[#00000036]">
										# SUPPLIER
									</p>
									{selectedFilters?.l3?.length > 0 ||
									selectedFilters?.l2?.length > 0 ||
									selectedFilters?.l1?.length > 0 ? (
										<div className="flex w-full pt-[.5vh]">
											<div className="w-[50%] flex flex-col pr-[2vh] justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
												<span>Top Supplier</span>
												<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
													{Object.keys(graphData)
														?.length > 0 &&
														graphData?.supplierCount &&
														numberFormatter(
															graphData
																?.supplierCount
																?.topsupplier,
															0
														)}
												</div>
											</div>
											<div className="w-[50%] flex flex-col pr-[2vh] justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
												<span>Tail Supplier</span>
												<div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
													{Object.keys(graphData)
														?.length > 0 &&
														graphData?.supplierCount &&
														numberFormatter(
															graphData
																?.supplierCount
																?.tailsupplier,
															graphData
																?.supplierCount
																?.tailsupplier >
																1000
																? 1
																: 0
														)}
												</div>
											</div>
										</div>
									) : (
										<div className="w-full h-full flex justify-center items-center opacity-[.8] pb-[2vh]">
											Please select a category to see the
											details
										</div>
									)}
								</div>
							)}
							{(activeTab == "category" ||
								activeTab == "supplier") && (
								<div
									className={`flex-1 ${
										selectedFilters?.l3?.length > 0 ||
										selectedFilters?.l2?.length > 0 ||
										selectedFilters?.l1?.length > 0 ||
										selectedFilters?.supplier?.length > 0
											? "min-w-[16.2vw]"
											: ""
									}flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start`}
									style={{ borderRadius: ".5vh" }}
								>
									<p
										className={`m-[1vh] text-center font-bold border-b-[1px] border-[#00000036] ${
											activeTab == "category" ||
											activeTab == "supplier"
												? ""
												: ""
										}`}
									>
										DISTRICT PERFORMANCE
									</p>
									{selectedFilters?.l3?.length > 0 ||
									selectedFilters?.l2?.length > 0 ||
									selectedFilters?.l1?.length > 0 ||
									selectedFilters?.supplier?.length > 0 ? (
										<div
											className={`flex w-full ${
												activeTab == "category" ||
												activeTab == "supplier"
													? "pl-[.5vh] mb-[1vh]"
													: ""
											} pt-[.5vh]`}
										>
											<div
												className={`w-[50%] flex flex-col ${
													activeTab == "category" ||
													activeTab == "supplier"
														? "flex-col pr-[0.5vh]"
														: "pr-[0.5vh]"
												} justify-center items-center gap-x-[1vh] border-r border-[#00000036]`}
											>
												<span className="text-nowrap">{`# District > avg GM%`}</span>
												<div className="font-bold text-[#008b00] bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
													{aboveAvgGMCount}
												</div>
											</div>
											<div
												className={`w-[50%] flex flex-col justify-center gap-x-[1vh] items-center`}
											>
												<span
													className={`${
														activeTab ==
															"category" ||
														activeTab == "supplier"
															? ""
															: "pl-[1vh]"
													}text-nowrap`}
												>{`# District < avg GM%`}</span>
												<div className="font-bold text-[#d55454] bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
													{belowAvgGMCount}
												</div>
											</div>
										</div>
									) : (
										<div className="w-full px-[1vh] h-full flex justify-center items-center opacity-[.8] pb-[2vh]">
											Please select a{" "}
											{activeTab == "category"
												? "category"
												: "supplier"}{" "}
											to see the details
										</div>
									)}
								</div>
							)}
							{activeTab == "supplier" && (
								<div
									className="flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start "
									style={{ borderRadius: ".5vh" }}
								>
									<div
										className={`flex ${
											selectedFilters?.supplier?.length >
											0
												? "flex-col"
												: ""
										} justify-center items-center m-[1vh] border-b-[1px] border-[#00000036]`}
									>
										<p className="text-center font-bold">
											FORWARD BUY*
										</p>
										<span className=" opacity-[0.8] ml-2">
											At supplier level
										</span>
									</div>
									{selectedFilters?.supplier?.length > 0 ? (
										<div className="flex w-full pt-[.5vh]">
											<div className="w-[100%] px-[1vh] flex justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
												<div className="font-bold text-[#008b00] bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
													{graphData?.nia
														? graphData?.nia
																?.totalBenefit &&
														  graphData?.nia
																?.totalBenefit >
																0
															? numberFormatter(
																	graphData
																		?.nia
																		?.totalBenefit,
																	2,
																	"$"
															  )
															: "-"
														: "-"}
												</div>
											</div>
										</div>
									) : (
										<div className="w-full px-[1vh] h-full flex justify-center items-center opacity-[.8] pb-[2vh]">
											Please select a supplier to see the
											details
										</div>
									)}
								</div>
							)}
						</div>
						{activeTab == "district" && (
							<div className="flex gap-[1vw] h-full ">
								<div
									className="flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start"
									style={{ borderRadius: ".5vh" }}
								>
									{selectedFilters?.district?.length > 0 ? (
										<div className="flex w-full py-[.5vh]">
											<div className="w-[100%] pr-[1vh] flex justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
												<span className="pl-[1vh]  font-bold">
													Opportunity
												</span>
												{graphData &&
													graphData.oppData &&
													Array.isArray(
														graphData.oppData
													) && (
														<div className="font-bold bg-[#F2F4F7] p-[1vh] w-[6vw] rounded-[.5vh] text-center">
															{numberFormatter(
																(graphData
																	.oppData[0]
																	?.total ||
																	0) +
																	(graphData
																		.oppData[1]
																		?.total ||
																		0) +
																	(graphData
																		.oppData[2]
																		?.total ||
																		0),
																2,
																"$"
															)}
														</div>
													)}
											</div>
										</div>
									) : (
										<div className="w-full h-full  font-bold flex justify-center items-center opacity-[.8]">
											Opportunity
										</div>
									)}
								</div>
								<div
									className="flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start"
									style={{ borderRadius: ".5vh" }}
								>
									{selectedFilters?.district?.length > 0 ? (
										<div className="flex w-full py-[.5vh]">
											<div className="w-[100%] pr-[1vh] flex justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
												<span className="pl-[1vh] font-bold">
													Portfolio Gap
												</span>
												<div className="font-bold bg-[#F2F4F7] p-[1vh] w-[6vw] rounded-[.5vh] text-center">
													{numberFormatter(
														selectedProjectType ===
															"Project"
															? 0
															: graphData
																	?.oppData?.[0]
																	?.total ||
																	0,
														2,
														"$"
													)}
												</div>
											</div>
										</div>
									) : (
										<div className="w-full h-full flex justify-center items-center opacity-[.8] py-[1vh]">
											Please select a district to see the
											details
										</div>
									)}
								</div>
								<div
									className="flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start"
									style={{ borderRadius: ".5vh" }}
								>
									{selectedFilters?.district?.length > 0 ? (
										<div className="flex w-full py-[.5vh]">
											<div className="w-[100%] pr-[1vh] flex justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
												<span className="pl-[1vh]  font-bold">
													Cost Optimization
												</span>
												<div className="font-bold bg-[#F2F4F7] p-[1vh] w-[6vw] rounded-[.5vh] text-center">
													{numberFormatter(
														graphData?.oppData?.[1]
															?.total ?? 0,
														2,
														"$"
													)}
												</div>
											</div>
										</div>
									) : (
										<div className="w-full h-full flex justify-center items-center opacity-[.8] py-[1vh]">
											Please select a district to see the
											details
										</div>
									)}
								</div>
								<div
									className="flex-1 statusCard bg-[#FFFFFF] text-black my-[0.5vh] flex flex-col justify-start"
									style={{ borderRadius: ".5vh" }}
								>
									{selectedFilters?.district?.length > 0 ? (
										<div className="flex w-full pt-[.5vh]">
											<div className="w-[100%] pr-[1vh] flex justify-center items-center gap-x-[1vh] border-r border-[#00000036]">
												<span className="pl-[1vh]  font-bold">
													Pricing Optimization
												</span>
												<div className="font-bold bg-[#F2F4F7] p-[1vh] w-[6vw] rounded-[.5vh] text-center">
													{numberFormatter(
														graphData?.oppData?.[2]
															?.total ?? 0,
														2,
														"$"
													)}
												</div>
											</div>
										</div>
									) : (
										<div className="w-full h-full flex justify-center items-center opacity-[.8] py-[1vh]">
											Please select a district to see the
											details
										</div>
									)}
								</div>
							</div>
						)}
					</div>
					<div
						className={`chart-flex contentBox ${
							activeTab != "district"
								? isVisible
									? "h-[71%]"
									: "h-[75%]"
								: isVisible
								? "h-[61%]"
								: "h-[67%]"
						} py-[1vh]`}
					>
						<div className="topSuppliers-container scatterChartContainer flex flex-col justify-start gap-y-[1vh] overflow-x-auto bg-white">
							{isGraphLoading || isSummaryGraphLoading ? (
								<Loader />
							) : (
								<PerformanceScatter
									isVisible={isVisible}
									data={scatterData}
									text="SUMMARY"
									refX={summaryData?.cagr * 100}
									refY={summaryData?.grossMargin * 100}
									view={viewBy}
									selectedViewBy={selectedViewBy}
									selectedSupplierCount={null}
									viewFor={[]}
									selectedScatter={selectedScatter}
									recommended={null}
									commoditySupplier={commoditySupplier}
									handleClick={(
										selected: string | null,
										isFilter: boolean = false
									) => handleClicks(selected, isFilter)}
									handleDrillDownSelection={(
										drillDownType: any,
										selectedData: any
									) => {
										handleDrillDownSelection(
											drillDownType,
											selectedData
										);
									}}
									highlight={highlight}
									updateHighlight={(value: any) => {
										setHighlight(value);
									}}
									updateViewBy={(item: any) => {
										setViewBy(item);
									}}
									activeTab={activeTab}
									filters={filterOptions}
									selectedFilters={selectedFilters}
									updateSelectedFilters={(
										item: any,
										view: any
									) => {
										setSelectedFilters(item);
										if (view == "Supplier") {
											if (item?.supplier?.length == 0) {
												getSummaryData(
													null,
													view,
													selectedFilters.l3,
													[],
													[]
												);
												getFilters(
													{
														...selectedFilters,
														supplier: [],
														district: [],
													},
													"supplier"
												);
											}
										} else if (view == "District") {
											if (item?.district?.length == 0) {
												getSummaryData(
													null,
													view,
													selectedFilters.l3,
													[],
													[]
												);
												getFilters(
													{
														...selectedFilters,
														district: [],
														supplier: [],
													},
													"district"
												);
											}
										} else {
											getSummaryData(
												null,
												view,
												[],
												[],
												[]
											);
										}
									}}
									filterUpdate={(
										value: any,
										filterEntity: any
									) => {
										handleFilterUpdate(value, filterEntity);
									}}
									getSummary={(
										view: any,
										selectedSupplier: any = null,
										selectedDistrict: any = null,
										isFilter: boolean = false
									) => {
										console.log(
											view,
											selectedSupplier,
											selectedDistrict,
											isFilter,
											"getsummary"
										);
										if (selectedSupplier) {
											if (viewBy === "District") {
												getSummaryData(
													null,
													"District",
													null,
													null,
													selectedSupplier
												);
											} else if (viewBy === "L3") {
												getSummaryData(
													null,
													"L3",
													selectedSupplier
												);
											} else {
												getSummaryData(
													null,
													view,
													null,
													selectedSupplier,
													[]
												);
											}
											setHighlight(null);
										} else if (selectedDistrict) {
											if (
												viewBy === "Supplier" &&
												!isFilter
											) {
												getSummaryData(
													null,
													"Supplier",
													null,
													selectedDistrict
												);
											} else if (
												viewBy === "L3" &&
												!isFilter
											) {
												getSummaryData(
													null,
													"L3",
													selectedDistrict
												);
											} else {
												getSummaryData(
													null,
													view,
													null,
													[],
													selectedDistrict
												);
											}
											setHighlight(null);
										}
									}}
									getBenchmarkingFilters={() => {
										supplierBenchmarkingFilters();
									}}
									performanceFlag={performanceFlag}
									updatePerformanceFlag={(flag: any) => {
										setPerformanceFlag(flag);
									}}
									performanceGraphData={performanceGraphData}
									updatePerformanceGraphData={(data: any) => {
										setPerformanceGraphData(data);
									}}
									benchmarkingDataFlag={benchmarkingDataFlag}
									legendColors={legendColors}
									detailView={detailView}
									updateDetailview={(flag: boolean) => {
										setDetailView(flag);
									}}
									handleClean={(value: any) => {
										handleClear(value);
									}}
								></PerformanceScatter>
							)}
						</div>
						<div className="topSuppliers-container flex flex-col justify-end gap-y-[1vh] overflow-x-auto">
							{isGraphLoading || isSummaryGraphLoading ? (
								<Loader />
							) : (
								<div className="flex flex-col gap-[4vh]">
									<div
										className={`flex ${
											isVisible
												? activeTab != "district"
													? "h-[41.2vh]"
													: "h-[34.6vh]"
												: activeTab != "district"
												? "h-[52.6vh]"
												: "h-[46.5vh]"
										}`}
									>
										<div
											className="flex justify-center items-center"
											style={{
												cursor:
													index !== 0
														? "pointer"
														: "default",
											}}
										>
											<AngleLeftIcon
												onClick={goPrev}
												height={"5vh"}
												width={"2vw"}
												className=" bg-[#d5d5d561] rounded-[1vh]"
												color={
													index === 0
														? "#ffffff3b"
														: "white"
												}
											/>
										</div>
										{
											<Carousel
												activeIndex={index}
												onSelect={handleSelect}
												style={{
													width: "100%",
													height: "100%",
												}}
											>
												{slides}
											</Carousel>
										}
										<div
											className="flex justify-center items-center"
											style={{
												cursor:
													index !== slides.length - 1
														? "pointer"
														: "default",
											}}
										>
											<AngleRightIcon
												onClick={goNext}
												height={"5vh"}
												width={"2vw"}
												className=" bg-[#d5d5d561] rounded-[1vh]"
												color={
													index === slides.length - 1
														? "#ffffff3b"
														: "white"
												}
											/>
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</MainContent>
			</div>
		</>
	);
};

const message = (
	<Notification type={"info"} header={`Exporting...`} closable>
		<p>Your file is being created. It will be download automatically</p>
	</Notification>
);

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => dispatch({ type: FILTERDATA, data: data }),
});
export default connect(null, mapDispatchToProps)(CategoryPerformance);
